import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MaterialModule } from '@shared/material/material.module';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { PipesModule } from '@pipes/pipes.module';
import { RouterModule } from '@angular/router';
import { BaseInputComponent } from './base-input.component';
import { TranslateModule } from '@ngx-translate/core';

@NgModule({
  declarations: [BaseInputComponent],
  imports: [CommonModule, MaterialModule, FormsModule, ReactiveFormsModule, PipesModule, RouterModule, TranslateModule],
  exports: [BaseInputComponent]
})
export class BaseInputModule {}
